export default __webpack_public_path__ + "static/m-service-1-8977c01fbd25c9fbec877dc4a9e3256e.jpg";